import { inject } from "@angular/core";

import { isInternalAppType } from "@azm/core/enums/app-types";
import { UserRoles } from "@azm/core/enums/user-roles";
import { AuthService } from "@azm/core/services/auth";
import { environment } from "@azm/environments/environment";

export function isInternalShellRoute(): boolean {
	if (isInternalAppType(environment.defaultAppType)) return true;
	const auth = inject(AuthService);
	const role = auth.userRole != null ? Number(auth.userRole) : NaN;
	return role === UserRoles.Internal;
}
